import { render, staticRenderFns } from "./pendingBetList9WTab.vue?vue&type=template&id=56b9f0c6&lang=pug"
import script from "./pendingBetList9WTab.vue?vue&type=script&lang=js"
export * from "./pendingBetList9WTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports